<template>
  <div class="body-section">
    <div>
      <div class="title-section" style="display: flex">
        <h1 class="title title-ruban">VOS INFORMATIONS DE COMPTE</h1>
        <div>
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <router-link to="Dashboard">
                  <span class="icon is-small">
                    <i class="fas fa-chevron-left" aria-hidden="true"></i>
                  </span>
                  <span>Accueil</span>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="page-seperate"></div>
    </div>

    <section
      class="container p-5"
      style="background: white; border: 1px solid #e9e9e9"
    >
      <div style="margin-left: 2vw">
        <p
          v-if="!$store.state.user.hasProfil"
          class="subtitle"
          style="display: inline"
        >
          merci de compléter votre profil
        </p>

        <b-field horizontal label="Nom :" required>
          <b-input required v-model="profil.name" ref="profil.name"> </b-input>
        </b-field>
        <b-field horizontal label="Prénom :" required>
          <b-input
            v-model="profil.surname"
            ref="profil.surname"
            type="text"
            required
          >
          </b-input>
        </b-field>
        <b-field horizontal label="Genre :" required>
          <b-input
            v-model="profil.gender"
            ref="profil.gender"
            type="text"
            required
          >
          </b-input>
        </b-field>
        <b-field horizontal label="Niveau de formation/Diplôme :" required>
          <b-input
            v-model="profil.studiesLevel"
            ref="profil.studiesLevel"
            type="text"
            required
          >
          </b-input>
        </b-field>
        <b-field horizontal label="Intitulé du poste :" required>
          <b-input
            v-model="profil.position"
            ref="profil.position"
            type="text"
            required
          >
          </b-input>
        </b-field>
        <b-field horizontal label="Nature :" required>
          <div class="block">
            <b-radio
              v-model="profil.rdoNatureService"
              name="natureService"
              native-value="Administration"
            >
              Administration
            </b-radio>
            <b-radio
              v-model="profil.rdoNatureService"
              name="natureService"
              native-value="Gestion"
            >
              Gestion
            </b-radio>
            <b-radio
              v-model="profil.rdoNatureService"
              name="natureService"
              native-value="Management"
            >
              Management
            </b-radio>
            <b-radio
              v-model="profil.rdoNatureService"
              name="natureService"
              native-value="Production"
            >
              Production
            </b-radio>
            <b-radio
              v-model="profil.rdoNatureService"
              name="natureService"
              native-value="Commercial"
            >
              Commercial
            </b-radio>
          </div>
        </b-field>
        <b-field horizontal label="Statut :" required>
          <div class="block">
            <b-radio
              v-model="profil.rdoNatureStatus"
              name="natureStatus"
              native-value="Administration"
            >
              Ouvrier
            </b-radio>
            <b-radio
              v-model="profil.rdoNatureStatus"
              name="natureStatus"
              native-value="Gestion"
            >
              Employé
            </b-radio>
            <b-radio
              v-model="profil.rdoNatureStatus"
              name="natureStatus"
              native-value="Management"
            >
              Cadre
            </b-radio>
            <b-field horizontal label="Autre :">
              <b-input
                horizontal
                v-model="profil.natureOther"
                type="text"
                label="Autre :"
              >
              </b-input>
            </b-field>
          </div>
        </b-field>

        <b-field horizontal label="Nombre de personnes encadrées :">
          <b-input v-model="profil.supportingNumber" type="number"> </b-input>
        </b-field>
        <b-field horizontal label="Entreprise / Établissement :" required>
          <b-input
            v-model="profil.compagny"
            ref="profil.compagny"
            type="text"
            label="Entreprise / Établissement :"
            required
          >
          </b-input>
        </b-field>
        <b-field
          horizontal
          label="Années d'ancienneté dans le poste :"
          required
        >
          <b-input
            v-model="profil.experience"
            ref="profil.experience"
            type="number"
            required
          >
          </b-input>
        </b-field>
        <b-field
          label="Votre type CCTI/MBTI (si vous avez passé l’un de ces indicateurs) :"
          horizontal
        >
          <b-input v-model="profil.CCTI_MBTI" type="text"> </b-input>
        </b-field>

        <div style="text-align: right">
          <b-button
            label="Enregistrer"
            type="is-primary"
            style="margin-bottom: 2em"
            @click="
              onSubmit();
              isLoading = true;
            "
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { addUserProfil } from "../services/dbService";
import { mapGetters } from "vuex";
export default {
  props: {
    profil: {
      type: Object,
      required: true,
      /* name, surname, gender, studiesLevel, position, rdoNatureService, rdoNatureStatus, natureOther, supportingNumber, compagny, experience, CCTI_MBTI*/
    },
    fromSurveyType: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    onSubmit() {
      // check validity
      var isValid = true;
      Object.values(this.$refs).forEach((input) => {
        input.checkHtml5Validity();

        isValid = isValid && input.isValid;
      });

      if (isValid) {
        addUserProfil(this.user, this.profil).then(() => {
          this.$store.dispatch("updateUserDashboard");

          this.$buefy.snackbar.open({
            message: "Votre profil a été sauvegardé.",
            queue: false,
          });
          this.$nextTick(() => {
            if (this.fromSurveyType != undefined) {
              this.$router.push("/survey/" + this.fromSurveyType);
            }
          });
        });
      } else {
        this.isLoading = false; // stop loading spiner

        this.$buefy.snackbar.open({
          message:
            "Une erreur a été détectée, merci de corriger le formulaire.",
          type: "is-warning",
          queue: false,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
